import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { VerticalResizer } from './Resizer';

const LayoutWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
`;

const LayoutRowOne = styled.div<{ height: number }>`
  margin: 10px 0 10px 0;
  overflow-y: auto;
  height: ${({ height }) => `${height}px`};
  background-color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : 'inherit')};
`;

const LayoutRowTwo = styled.div`
  padding: 0;
  white-space: nowrap;
  background-color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : 'inherit')};

  > div {
    margin: 0 auto;
  }
`;

interface TwoRowsLayoutOwnProps {
  upperRow: JSX.Element | null;
  bottomRow: JSX.Element | null;
  isUpperRowActive?: boolean;
}

const ResizableTwoRowsLayout = ({ upperRow, bottomRow, isUpperRowActive }: TwoRowsLayoutOwnProps) => {
  const [upperRowHeight, setUpperRowHeight] = useState(180);
  useEffect(() => {
    const savedHeight = localStorage.getItem('layout-row-width');
    if (savedHeight) {
      setUpperRowHeight(parseInt(savedHeight));
    }
  }, []);

  const startResizing = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    const startY = event.clientY;
    const startHeight = upperRowHeight;

    const handleMouseMove = (moveEvent: MouseEvent) => {
      const currentY = moveEvent.clientY;
      const diffY = currentY - startY;
      const newHeight = Math.max(50, startHeight + diffY);
      setUpperRowHeight(newHeight);
      localStorage.setItem('layout-row-width', newHeight.toString());
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <LayoutWrapper id="scroller">
      {upperRow && isUpperRowActive && (
        <>
          <LayoutRowOne height={upperRowHeight}>{upperRow}</LayoutRowOne>
          <VerticalResizer style={{ marginBottom: 10 }} onMouseDown={startResizing} />
        </>
      )}

      <LayoutRowTwo>{bottomRow}</LayoutRowTwo>
    </LayoutWrapper>
  );
};

export default ResizableTwoRowsLayout;
